module.exports = __webpack_public_path__ + "img/sprinkle-19.8ef5b4e9.webp";